import { ITexturedShapeDrawableObject, instanceOfITexturedShapeDrawableObject } from "./ITexturedShapeDrawableObject";

export interface ICircleObject extends ITexturedShapeDrawableObject {}

export function instanceOfICircleObject(instance: any): instance is ICircleObject {
  return instanceOfITexturedShapeDrawableObject<ICircleObject>(instance, "circle");
}
